import * as React from 'react';
import { DetailProducts } from '../../dto/Types/ProductType';

const GenericProfile: React.FC<{ size?: number | string; cornerRadius?: number; sx?: React.CSSProperties; product?: DetailProducts }> = ({
  size = 50,
  cornerRadius,
  sx,
  product,
}) => {
  if (product === 'bot-detection') {
    return (
      <>
        <svg width="176" height="176" viewBox="0 0 152 152" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="176" height="176" rx="4.63636" fill="#DEE2E9" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M43.5 46H108.5V107.667H43.5V46ZM48.5 51V64.3333H103.5V51H48.5ZM48.5 102.667V69.3333H103.5V102.667H48.5Z"
            fill="white"
          />
          <path
            d="M55.1673 54.3333C53.3264 54.3333 51.834 55.8257 51.834 57.6667C51.834 59.5077 53.3264 61 55.1673 61C57.0083 61 58.5007 59.5077 58.5007 57.6667C58.5007 55.8257 57.0083 54.3333 55.1673 54.3333Z"
            fill="white"
          />
          <path
            d="M65.1673 54.3333C63.3264 54.3333 61.834 55.8257 61.834 57.6667C61.834 59.5077 63.3264 61 65.1673 61C67.0083 61 68.5007 59.5077 68.5007 57.6667C68.5007 55.8257 67.0083 54.3333 65.1673 54.3333Z"
            fill="white"
          />
        </svg>
      </>
    );
  }
  const productsWithBuildingAvatar: DetailProducts[] = ['ip', 'domain', 'bot-detection'];
  const returnBuildingAvatar = product && productsWithBuildingAvatar.includes(product);

  return (
    <>
      {returnBuildingAvatar ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: size, height: size, borderRadius: cornerRadius, ...sx }}
          data-name="Layer 1"
          viewBox="0 -8 72 72"
          fill="#dee2e9"
        >
          <path fill="#dee2e9" d="M0 -8h72v72H0z" />
          <path
            d="M61.26 46.71h-.64c-.35 0-.35-.42-.35-.42V16.7a1.35 1.35 0 0 0-1.34-1.36h-10.3a.33.33 0 0 1-.35-.36v-5.7c0-.06 0-.12.21-.12a.75.75 0 0 0 .74-.75V7.07a.75.75 0 0 0-.74-.75H24.56a.75.75 0 0 0-.74.75v1.34a.75.75 0 0 0 .74.75.21.21 0 0 1 .22.22v5.47s0 .49-.28.49H13.37A1.35 1.35 0 0 0 12 16.7v29.68c0 .29-.15.33-.45.33h-.51a.75.75 0 0 0-.74.75V49a.75.75 0 0 0 .74.76h50.22A.75.75 0 0 0 62 49v-1.54a.75.75 0 0 0-.74-.75Zm-21.9-24.88h4.43a.6.6 0 0 1 .59.6v4.51a.6.6 0 0 1-.59.6h-4.43a.59.59 0 0 1-.59-.6v-4.51a.59.59 0 0 1 .59-.6ZM38.77 19v-4.47a.59.59 0 0 1 .59-.6h4.43a.6.6 0 0 1 .59.6V19a.6.6 0 0 1-.59.6h-4.43a.59.59 0 0 1-.59-.6Zm.59 10.41h4.43a.6.6 0 0 1 .59.6v4.51a.6.6 0 0 1-.59.6h-4.43a.59.59 0 0 1-.59-.6v-4.47a.59.59 0 0 1 .59-.6Zm.64 9.1a.6.6 0 0 1 .59.6v7a.6.6 0 0 1-.59.6h-6.84a.6.6 0 0 1-.6-.6v-7a.6.6 0 0 1 .6-.6ZM34.3 19a.6.6 0 0 1-.59.6h-4.43a.59.59 0 0 1-.59-.6v-4.47a.59.59 0 0 1 .59-.6h4.43a.6.6 0 0 1 .59.6V19Zm-5 2.79h4.43a.6.6 0 0 1 .59.6v4.51a.6.6 0 0 1-.59.6h-4.45a.59.59 0 0 1-.59-.6v-4.47a.59.59 0 0 1 .59-.6Zm0 7.62h4.43a.6.6 0 0 1 .59.6v4.51a.6.6 0 0 1-.59.6h-4.45a.59.59 0 0 1-.59-.6v-4.47a.59.59 0 0 1 .59-.6ZM50 22.29a.6.6 0 0 1 .59-.6H55a.6.6 0 0 1 .6.6v4.51a.6.6 0 0 1-.6.6h-4.39a.6.6 0 0 1-.59-.6Zm0 7.9a.6.6 0 0 1 .59-.6H55a.6.6 0 0 1 .6.6v4.51a.6.6 0 0 1-.6.6h-4.39a.6.6 0 0 1-.59-.6Zm0 7.62a.6.6 0 0 1 .59-.6H55a.6.6 0 0 1 .6.6v4.51a.6.6 0 0 1-.6.6h-4.39a.6.6 0 0 1-.59-.6ZM16.67 22.29a.6.6 0 0 1 .59-.6h4.43a.59.59 0 0 1 .59.6v4.51a.59.59 0 0 1-.59.6h-4.43a.6.6 0 0 1-.59-.6Zm0 7.9a.6.6 0 0 1 .59-.6h4.43a.59.59 0 0 1 .59.6v4.51a.59.59 0 0 1-.59.6h-4.43a.6.6 0 0 1-.59-.6Zm0 7.62a.6.6 0 0 1 .59-.6h4.43a.59.59 0 0 1 .59.6v4.51a.59.59 0 0 1-.59.6h-4.43a.6.6 0 0 1-.59-.6Z"
            data-name="Layer 5"
            fill="#fff"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          data-name="Generic avatar"
          viewBox="0 0 96 96"
          style={{ width: size, height: size, borderRadius: cornerRadius, ...sx }}
          fill="#fff"
          data-testid="generic-profile-img"
        >
          <path fill="#dee2e9" d="M0 0h96v96H0z" />
          <path
            fill="#fff"
            d="M80.6 62.7c-4.2-3.9-9.2-7-14.8-9.1-5.6-2.1-11.7-3.2-17.8-3.2s-12.2 1.1-17.8 3.2c-5.6 2.1-10.6 5.2-14.8 9.1-.6.6-1 1.4-1 2.2v13.4c0 .9.4 1.7 1.2 2.3s1.7 1 2.7 1h59.4c1 0 2-.4 2.7-1 .7-.6 1.1-1.5 1.1-2.4V64.8c0-.8-.4-1.6-1-2.2ZM48.3 45.8c8.7 0 15.7-7 15.7-15.7s-7-15.7-15.7-15.7-15.7 7-15.7 15.7 7 15.7 15.7 15.7Z"
          />
        </svg>
      )}
    </>
  );
};
export default GenericProfile;
